<template>
    <span v-if="type == 'invoice' && isAdmin">
        <div class="text-right">
        </div>
    
        <div class="text-right">
            <div class="text-2xl text-gray-dark font-bold leading-tight border border-gray-dark px-2 py-2 rounded inline-block">
                # of Boxes: <span class="w-20 inline-block border-b border-gray-dark">&nbsp;</span>
            </div>
        </div>
    </span>

    <div class="flex justify-between mt-4">
        <div>
            <div class="text-4xl">
                <span class="text-green"><b>PRODUCE</b></span>
                <span class="ml-2 text-red"><b>EXPRESS</b></span>
            </div>
            <div v-if="order.ship_date >= '2024-10-09'" class="small">
                1149 Commerce Way<br />
                Woodstock, ON N4V 0A2<br />
                519-539-9333
            </div>
            <div v-else class="small">
                454 Innovation Way, Unit 10<br />
                Woodstock, ON N4V 0A2<br />
                519-539-9333
            </div>
        </div>
        <div v-if="type == 'outlet_order'">
            <div v-if="order.gift" class="small">
                <div class="text-right">
                    <span style="color:#d41534;" class="text-3xl"><b>GIFT ORDER!</b></span>
                </div>
            </div>
        </div>
        <div v-if="type == 'invoice'">
            <div class="text-2xl text-gray-dark font-bold">INVOICE</div>
            <div class="flex">
                <div class="flex flex-1 whitespace-nowrap pr-1">Invoice #:</div>
                <div class="flex flex-1">{{ order.id}}</div>
            </div>
            <div class="flex">
                <div class="flex flex-1 pr-1">Date:</div>
                <div class="flex flex-1 whitespace-nowrap">{{ formatDate(order.ship_date) }}</div>
            </div>
            <div v-if="order.payment_status != 'paid' && order.payment_terms_def" class="flex">
                <div class="flex flex-1 pr-1">Terms:</div>
                <div class="flex flex-1 whitespace-nowrap">{{ order.payment_terms_def }}</div>
            </div>
            <div v-if="order.payment_status != 'paid' && order.payment_due" class="flex">
                <div class="flex flex-1 pr-1">Due:</div>
                <div class="flex flex-1 whitespace-nowrap">{{ formatDate(order.payment_due) }}</div>
            </div>
        </div>
    </div>

    <div v-if="type == 'outlet_order'">
        <table>
            <thead>
                <tr>
                    <template v-if="order.gift">
                        <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/3">
                            To
                        </th>
                        <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/3">
                            From
                        </th>
                    </template>
                    <template v-else>
                        <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold" :class="{'w-1/3': order.billing_address_1, 'w-1/2': order.billing_address_1}">
                            Customer Info
                        </th>
                        <th v-if="order.billing_address_1" class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/3">
                            Billing Address
                        </th>
                    </template>
                    <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold" :class="{'w-1/3': order.gift || order.billing_address_1, 'w-1/2': !order.gift && !order.billing_address_1}">
                        Order Info
                    </th>
                </tr>
                <tr>
                    <template v-if="order.gift">
                        <td class="font-semibold align-top w-1/3">
                            <div>{{ order.gift_to }}</div> 
    
                            <span v-if="order.shipping_address_1">
                                <div>{{ order.shipping_address_1 }} {{ order.shipping_address_2 }}</div> 
                                <div>{{ order.shipping_city }} {{ order.shipping_province }} {{ order.shipping_postal }}</div> 
                            </span>
                        </td>
                        
                        <td class="font-semibold align-top w-1/3">
                            <div>{{ order.billing_first_name }} {{ order.billing_last_name }}</div>
                            <span v-if="order.gift_message">
                                <div>Message: </div>
                                <i>{{ order.gift_message }}</i>
                            </span>
                        </td>
                    </template>
                    <template v-else>
                        <td class="font-semibold align-top" :class="{'w-1/3': order.billing_address_1, 'w-1/2': order.billing_address_1}">
                            <div>{{ order.shipping_first_name }} {{ order.shipping_last_name }}</div>
                            <div>{{ order.shipping_address_1 }} {{ order.shipping_address_2 }}</div>
                            <div>{{ order.shipping_city }} {{ order.shipping_province }} {{ order.shipping_postal }}</div> 
                            <div>{{ order.shipping_phone }}</div> 
                        </td>
                        <td v-if="order.billing_address_1" class="font-semibold align-top w-1/3">
                            <div>{{ order.billing_first_name }} {{ order.billing_last_name }}</div>
                            <div>{{ order.billing_address_1 }} {{ order.billing_address_2 }}</div>
                            <div>{{ order.billing_city }} {{ order.billing_province }} {{ order.billing_postal }}</div> 
                            <div>{{ order.billing_phone }}</div> 
                        </td>
                    </template>
    
                    <td class="font-semibold align-top" :class="{'w-1/3': order.gift || order.billing_address_1, 'w-1/2': !order.gift && !order.billing_address_1}">
                        <div><span class="inline-block w-24">Order #:</span>{{ order.order_number }}</div>
                        <div>
                            <span class="inline-block w-24">Ordered On:</span>{{ formatDate(order.created_at) }}
                            &nbsp;&nbsp;<span class="text-gray-500 small hide_if_small">{{ formatTime(order.created_at) }}</span>
                        </div>
                        
                        <div v-if="order.shipping_method == 'delivery'">
                            <span class="inline-block w-24">Delivery Date:</span>{{ formatDate(order.ship_date) }}
                            &nbsp;&nbsp;<span class="text-gray-500 small hide_if_small">{{ order.shipping_time }}</span>
                        </div>
                        <div v-else>
                            <span class="inline-block w-24">Pickup Date:</span>{{ formatDate(order.ship_date) }}
                            &nbsp;&nbsp;<span class="text-gray-500 small hide_if_small capitalize">{{ (order.shipping_time).replaceAll('_',' ') }}</span>
                        </div>
                    </td>
                </tr>
            </thead>
        </table>
    </div>
    <div v-else>
        <table>
            <thead>
                <tr>
                    <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/2">
                        <span v-if="type == 'confirmation'">Customer Info</span>
                        <span v-if="type == 'invoice'">Bill To</span>
                    </th>
                    <th class="pt-6 pb-2 text-left text-2xl text-gray-dark font-bold w-1/2">
                        Order Info
                    </th>
                </tr>
                <tr>
                    <td class="font-semibold align-top">
                        <div>{{ order.customer.name }}</div>
                        <div>{{ order.customer.address_1 }}</div>
                        <div v-show="order.customer.address_2">{{ order.customer.address_2 }}</div>
                        <div class="mb-2">{{ order.customer.city }} {{ order.customer.province }} {{ order.customer.postal_code }}</div>
                        <div v-show="order.customer.phone">T: {{ order.customer.phone }}</div>
                        <div v-show="order.customer.emails">
                            <ul class="leading-tight">
                                <li v-for="email in order.customer.emails" :key="email">{{ email }}</li>
                            </ul>
                        </div>
                    </td>
                    <td v-if="type == 'confirmation'" class="font-semibold align-top">
                        <div><span class="inline-block w-24">Order #:</span>{{ order.id }}</div>
                        <div><span class="inline-block w-24">Ordered On:</span>{{ formatDate(order.order_date) }}</div>
                        <div>
                            <span class="inline-block w-24">
                                {{ order.shipping_method === 'pickup' ? 'Pickup' : 'Ship' }} Date:
                            </span>{{ formatDate(order.ship_date) }}
                        </div>
                        <div v-if="order.notes">
                            <span class="block">
                                {{ order.shipping_method === 'pickup' ? 'Pickup' : 'Shipping' }} Instructions:
                            </span>
                            {{ order.notes }}
                        </div>
                    </td>
                    <td v-if="type == 'invoice'" class="font-semibold align-top">
                        <div><span class="inline-block w-32">Ordered On:</span>{{ formatDate(order.order_date) }}</div>
                        <div><span class="inline-block w-32">Ship Date:</span>{{ formatDate(order.ship_date) }}</div>
                        <div><span class="inline-block w-32">Shipping Method:</span><span class="capitalize">{{ order.shipping_method }}</span></div>
                    </td>
                </tr>
            </thead>
        </table>
    </div>
</template>

<script>
import { DateTime } from "luxon";
import UseUserAuth from '@/Composables/UseUserAuth';
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
    },

    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return { isAdmin }
    },

    props: ['order', 'type'],

    methods: {
        formatDate(date) {
            if (date) {
                let dt = DateTime.fromISO(date);
                return dt.toLocaleString(DateTime.DATE_MED);
            }
            return '';
        },

        formatTime(timestamp) {
            let date = DateTime.fromSQL(timestamp).invalid ? DateTime.fromISO(timestamp) : DateTime.fromSQL(timestamp);

            if (date.c.hour === 0 && date.c.minute === 0 && date.c.second === 0) {
                return '';
            }

            return date.toFormat('h:mm a');
        },
    },
}

</script>
